import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const XCloseIcon = ({ ...props }: SvgIconProps) => {
  return (
    <SvgIcon {...props} width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M18 6L6 18M6 6L18 18'
        stroke='#14191F'
        strokeOpacity='0.6'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </SvgIcon>
  );
};

export default XCloseIcon;
